// extracted by mini-css-extract-plugin
export default {"question":"Question_question__JEPLI","bg_shadow":"Question_bg_shadow__SC-Ss"};